<template>
  <van-field
    type="number"
    v-model="val"
    :label="label"
    :placeholder="placeholder || label"
    :required="required"
    :rules="rules"
    :readonly="readonly"
    :clearable="clearable"
    @input="change"
    @blur="blur"
  >
    <template #button>
      <slot name="button" />
    </template>
  </van-field>
</template>
<script>
import CONST from '@/utils/const'
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    value: {
      type: [String, Number],
      default: null
    },
    maxlength: {
      type: [String, Number],
      default: CONST.DECIMAL.DEFAULT_MAX_NUM
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function() {
        return [{ required: this.required, message: '请输入' + this.label }]
      }
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      val: this.value ? parseFloat(this.value) : null
    }
  },
  watch: {
    value: function(value) {
      this.val = value
    }
  },
  methods: {
    change(value) {
      this.$emit('change', value ? parseFloat(value) : null)
    },
    blur() {
      this.$emit('blur', this.val ? parseFloat(this.val) : null)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/BaseInputNumber.vue